import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class SentryService {
  public init(): void {
    if (!Sentry.isInitialized() && environment.sentryEnable) {
      Sentry.init({
        environment: environment.sentryEnv,
        dsn: environment.sentryDns,
        integrations: [
          // Registers and configures the Tracing integration,
          // which automatically instruments your application to monitor its
          // performance, including custom Angular routing instrumentation
          Sentry.browserTracingIntegration(),
          // integration client for Angular
          Sentry.httpClientIntegration(),
          // Registers the Replay integration,
          // which automatically captures Session Replays
          Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
          }),
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.0,

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['/api'],

        // Capture Replay for 5% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.05,
        replaysOnErrorSampleRate: 1.0,
      });
      console.info('Analytics are enabled because you have accepted analytical cookies.');
    }
  }
}
